import { render } from "./IssueCard.vue?vue&type=template&id=114c3ec9&scoped=true"
import script from "./IssueCard.vue?vue&type=script&lang=js"
export * from "./IssueCard.vue?vue&type=script&lang=js"

import "./IssueCard.vue?vue&type=style&index=0&id=114c3ec9&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-114c3ec9"]])

export default __exports__